import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import BaseUrl from "../Components/BaseUrl";
import Cookies from "js-cookie";

const Onboardingstep8 = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = React.useState(true);
  
 
  const [switchState, setSwitchState] = useState({});
  

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };
  const validateForm = () => {
    let isValid = true;
    let errors = {};

   

    
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user_id = Cookies.get("user_id");
    if (validateForm()) {
      const info = window.localStorage.getItem("looking_for_job");
      const looking_for_job = info === "1" ? true : false;
      const share_with_recruiters = checked ? true : false;
      const requestdata = {
        looking_for_job,
        share_with_recruiters,
      };
      console.log(requestdata);
      
        try {
          const response = await axios.post(BaseUrl+"onboarding/step8", requestdata,
            {
              headers: {
                "user-id": user_id,
              },
            }
          );
          if (response.data.status === 200) {
            Cookies.set("token", response.data.data.token, { expires: 1, secure: true, sameSite: "Strict" });
            navigate("/user/home");
          }
        } catch (error) {
          console.error(error);
        }

    }
  };
  const CustomSwitch = styled(Switch)(({ theme }) => ({
    transform: "scale(1.5)", 
    "& .MuiSwitch-thumb": {
      width: 24,
      height: 24,
    },
    "& .MuiSwitch-switchBase": {
      padding: 12,
    },
  }));
  return (
    <div className="flex flex-col items-center justify-start mt-16 min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
      <div className="w-full text-center mb-4">
        <p className="text-2xl mb-2 w-full">
          Let recruiters know you are open to new jobs
        </p>
      </div>
      <div className="w-full max-w-sm  ">
        <div className="border-2 border-gray-300 rounded-md">
          <div className="flex flex-col bg-white rounded-md items-center justify-center">
            <img
              src="/Images/Onboarding/onboarding.png"
              alt="onboarding"
              className="w-2/4"
            />
          </div>
          <div className="flex  items-center ">
            <div className="w-3/4 p-4">
              <p className="text-[16px] text-black font-medium">
                Share with recruiters
              </p>
              <p className="text-[12px] text-gray-500">
                This will show people using LS Linkup Recruiter that you are
                looking for a new job
              </p>
            </div>
            <div className="w-1/4 flex items-center justify-center p-4">
              <Switch
                checked={checked}
                onChange={handleChange}
                inputProps={{ "aria-label": "controlled" }}
              />
            </div>
          </div>
        </div>
        <div>
          <p className="text-[14px] text-gray-500 mt-4">
            We take steps to not show recruiters at your current comapany,
            though we can't guarantee complete privacy.{"  "}
            <span className="text-blue-500">Learn more about your privacy</span>
          </p>
        </div>
        <div className="mt-6">
          <button
            className="bg-[#0A66C2] hover:bg-blue-700 text-white text-lg font-bold py-2 px-4 h-12 rounded-full w-full"
            type="button"
            onClick={handleSubmit}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Onboardingstep8;
